<template>
    <div class="row">
        <div class="col-md-12">
            <div class="p-r-15" >
                <div style="border: 1px solid #878d99; padding: 10px; background: white; margin-bottom: 20px">
                    <h4>Event Data (Last 24 hours) </h4>
                    <h6>
                        <i><b>Last Updated</b> - {{ currentTime }} (PST/PDT)</i>
                    </h6>
                    <el-table
                        :data="eventData"
                        v-loading="eventLoader"
                        style="width: 100%; border: 1px solid #878d99; padding: 5px"
                        height="250"
                    >
                        <el-table-column prop="timeslot" label="Time" width="170"></el-table-column>
                        <el-table-column prop="requests" label="Requests"></el-table-column>
                        <el-table-column prop="bids" label="Bids"></el-table-column>
                        <el-table-column prop="rejects" label="Rejects"></el-table-column>
                        <el-table-column prop="wins" label="Wins"></el-table-column>
                        <el-table-column prop="invalid_wins" label="Invalid Wins"></el-table-column>
                        <el-table-column prop="sib_impressions" label="SIB Impressions" width="150"></el-table-column>
                        <el-table-column prop="serp_clicks" label="SERP Clicks"></el-table-column>
                        <el-table-column prop="spend" label="Spend"></el-table-column>
                    </el-table>
                    <h4>Revenue Data (Last 24 hours)</h4>
                    <h6>
                        <i><b>Last Updated</b> - {{ currentTime }} (PST/PDT)</i>
                    </h6>
                    <el-table
                        :data="revenueData"
                        v-loading="revenueLoader"
                        style="width: 100%; border: 1px solid #878d99; padding: 5px"
                        height="250"
                    >
                        <el-table-column prop="timeslot" label="Time" width="170"></el-table-column>
                        <el-table-column prop="clicks" label="Clicks"></el-table-column>
                        <el-table-column prop="revenue" label="Revenue"></el-table-column>
                        <el-table-column prop="rpc" label="RPC"></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// dimensions item, devices, browsers, changeItemFormat, countries, creativeList
export default {
    props: ['eventData', 'revenueData', 'eventLoader', 'revenueLoader', 'currentTime'],
    data() {
        return {
        };
    },    
};
</script>



// WEBPACK FOOTER //
// AdspotData.vue?a93e6b42